export default __webpack_public_path__ + "static/media/p2p-banners.c8436f11.webp";